import _slicedToArray from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { addDispensaryRoutes, addProductRoutes, buildBaseRoute } from '../helpers/route-helpers.js';
export function useSharedPaths() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    product = _ref.product,
    dispensary = _ref.dispensary,
    isDemo = _ref.isDemo,
    isEmbedded = _ref.isEmbedded,
    isKiosk = _ref.isKiosk,
    isStoreFront = _ref.isStoreFront;
  var _buildBaseRoute = buildBaseRoute({
      dispensary: dispensary,
      isDemo: isDemo,
      isEmbedded: isEmbedded,
      isKiosk: isKiosk,
      isStoreFront: isStoreFront
    }),
    _buildBaseRoute2 = _slicedToArray(_buildBaseRoute, 2),
    href = _buildBaseRoute2[0],
    route = _buildBaseRoute2[1];
  var _addDispensaryRoutes = addDispensaryRoutes({
    href: href,
    route: route,
    dispensary: dispensary
  });
  var _addDispensaryRoutes2 = _slicedToArray(_addDispensaryRoutes, 2);
  href = _addDispensaryRoutes2[0];
  route = _addDispensaryRoutes2[1];
  if (product) {
    var _addProductRoutes = addProductRoutes({
      href: href,
      route: route,
      product: product
    });
    var _addProductRoutes2 = _slicedToArray(_addProductRoutes, 2);
    href = _addProductRoutes2[0];
    route = _addProductRoutes2[1];
  }
  return {
    href: href,
    route: route
  };
}